<div class="row">
  @for (heading of headings; track heading) {
    <div [id]="prefix + heading" class="col" (click)="headingClick(heading)">
      @if (!isBlank(heading)) {
        <div class="heading-text">
          <span>{{heading | titlecase}}</span>
        </div>
        <app-column-sort-icon [id]="'sort-icon-' + prefix + heading" [ordering]="ordering" [fieldName]="heading"></app-column-sort-icon>
      }
    </div>
  }
</div>